<template>
	<div class="double-calendar">
		<div class="flex-top gap-16">
			<Calendar
				class="availability-calendar"
				context="double"
				:availabilities="true"
				:jobs="true"
				:user="userId"
				v-bind="$attrs"
				v-on="$listeners"
				@date:click="onDateClick"
				@next="onNext"
				@prev="onPrevious"
				ref="leftCalendar">
			</Calendar>
			<Calendar 
				class="availability-calendar" 
				context="double" 
				:availabilities="true" 
				:jobs="true" 
				:user="userId" 
				:date="nextMonth"
				v-bind="$attrs" 
				v-on="$listeners" 
				@date:click="onDateClick" 
				@next="onNext" 
				@prev="onPrevious"
				ref="rightCalendar">
			</Calendar>
		</div>
		<CalendarLegend :showJobs="true" :showAvailabilities="true" :isOwnCalendar="true" class="mt-32"/>
	</div>
</template>

<script>
import { DateTime } from 'luxon';
import Calendar from '@/components/calendars/Calendar';
import { toGuid } from '@/helpers/convert';
import CalendarLegend from '@/components/calendars/CalendarLegend';

export default {
	name: 'DoubleAvailabilityCalendar',
	components: {
		Calendar,
		CalendarLegend
	},
	inheritAttrs: false,
	props: {
		user: {
			default: null,
		},
	},
	data() {
		return {
			availability: null,
			jobs: null,
			dateLeft: '',
			dateRight: '',
		};
	},
	computed: {
		selectedDates() {
			return this.$store.getters['availability/selectedDates'];
		},
		nextMonth() {
			let month = DateTime.now().month + 1;
			let year = DateTime.now().year;

			if (month == 13) {
				month = 1;
				year = year + 1;
			}

			return DateTime.local(year, month).toISO();
		},
		userId() {
			return toGuid(this.user) || this.$activeUser?.id || null;
		},
	},
	methods: {
		onDateClick(date) {
			if (!date.jobs.length) {
				this.$store.commit('availability/toggleSelectedDate', date);
			}
		},
		onPrevious(prevMonth) {
			const monthMinusTwo = DateTime.fromMillis(prevMonth).minus({
				months: 1
			}).toMillis();
			this.$refs.leftCalendar.setView(monthMinusTwo);
			this.$refs.rightCalendar.setView(prevMonth);
		},
		onNext(nextMonth) {
			const monthPlusTwo = DateTime.fromMillis(nextMonth).plus({
				months: 1
			}).toMillis();
			this.$refs.leftCalendar.setView(nextMonth);
			this.$refs.rightCalendar.setView(monthPlusTwo);
		},
	},
	created() {
		let month = DateTime.now().month + 1;
		let year = DateTime.now().year;

		if (month == 13) {
			month = 1;
			year = year + 1;
		}

		this.dateRight = DateTime.local(year, month).toISO();
	},
};
</script>
